import { DialogDisclosure, DialogStateReturn } from 'reakit/Dialog';
import ThumbUpFillIcon from 'remixicon-react/ThumbUpFillIcon';
import ThumbDownFillIcon from 'remixicon-react/ThumbDownFillIcon';

interface FeedbackBannerProps {
  dialog: DialogStateReturn;
}

export default function FeedbackBanner({ dialog }: FeedbackBannerProps) {
  return (
    <div className="lg:py-8">
      <div className="pt-6 border-t border-primary-200 md:flex md:items-center md:space-x-6">
        <div className="w-full">
          <h4 className="text-cornflower text-lg md:text-xl font-medium">
            Did you find this page useful?
          </h4>
          <p className="leading-relaxed text-primary-300">
            Your feedback helps us improve our docs, and product.
          </p>
        </div>
        <div className="flex items-center">
          <DialogDisclosure
            {...dialog}
            as="button"
            className="appearance-none p-3 flex items-center justify-center text-gray-500 hover:text-cornflower transition duration-75 ease-in-out focus:outline-none"
          >
            <ThumbUpFillIcon className="w-6 h-6" aria-hidden="true" />
            <span className="sr-only">Yes</span>
          </DialogDisclosure>
          <DialogDisclosure
            {...dialog}
            as="button"
            className="appearance-none p-3 flex items-center justify-center text-gray-500 hover:text-cornflower transition duration-75 ease-in-out focus:outline-none"
          >
            <ThumbDownFillIcon className="w-6 h-6" aria-hidden="true" />
            <span className="sr-only">No</span>
          </DialogDisclosure>
        </div>
      </div>
    </div>
  );
}
